import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Data fetched during SSR is handed to the browser; don't immediately
        // refetch it on hydration.
        staleTime: 60_000,
        refetchOnWindowFocus: false,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    trailingSlash: "never",
  });

  // Dehydrates the query cache into the SSR payload and rehydrates it on the
  // client, so route-loader data isn't re-fetched after hydration.
  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
};
